module.exports = __webpack_public_path__ + "images/category_lp/car/assessment_achievements/3_cef58be2961cca0e2321713b11606e10.png";